module.exports = __webpack_public_path__ + "img/m-bg5.c0b6ce63.png";